var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      zoom: 1.1
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4320_33863",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V18H18V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4320_33863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 8.0625C15 7.01414 15 6.30245 14.8287 5.88896C14.6004 5.33765 14.1623 4.89963 13.6111 4.67127C13.1975 4.5 12.6734 4.5 11.625 4.5C10.8536 4.5 10.0821 4.5 9.31065 4.5C9.1842 4.5 9.12097 4.5 9.06008 4.49669C8.5482 4.46891 8.06115 4.26718 7.67955 3.92488C7.6341 3.88413 7.5894 3.83942 7.5 3.75C7.41058 3.66058 7.36587 3.61587 7.32045 3.57512C6.93886 3.23282 6.45182 3.03109 5.93995 3.00331C5.87903 3 5.8158 3 5.68934 3C5.4929 3 5.29645 3 5.1 3C3.83988 3 3.20982 3 2.72852 3.24523C2.30515 3.46095 1.96095 3.80515 1.74523 4.22852C1.5 4.70982 1.5 5.33988 1.5 6.6C1.5 8.2 1.5 9.8 1.5 11.4C1.5 12.6602 1.5 13.2901 1.74523 13.7715C1.96095 14.1949 2.30515 14.539 2.72852 14.7548C3.20982 15 3.83988 15 5.1 15C6.15 15 7.2 15 8.25 15",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75353 9C4.75353 9 2.77564 10.7737 2.4952 11.9122C2.21476 13.0506 2.24997 13.4665 2.4952 13.8982C2.71092 14.2779 3.05512 14.5866 3.47849 14.78C3.95979 15 4.58985 15 5.84997 15C7.94997 15 10.05 15 12.15 15C13.4101 15 13.5594 15 14.0408 14.78C14.4641 14.5866 14.8083 14.2779 15.024 13.8982C15.1508 13.675 15.2821 12.9717 15.7124 11.9122C16.1146 10.922 16.8049 9.58606 17.25 9H4.75353Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoc);
export default __webpack_public_path__ + "static/media/icon-doc.c0a0b2283dbfc3bc50bc4e791d67cdd3.svg";
export { ForwardRef as ReactComponent };